import { Component, Input } from '@angular/core';
import { SummaryComponent } from 'components/layout/summary/summary.component';
import { SettlementStatus } from 'enums/SettlementStatus';
import { AccountingPlansLedgerPostsAmounts } from 'models/AccountingPlansLedgerPostsAmounts';
import { SettlementModel } from 'models/generated/Entities.GormCrm.Settlement';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { CurrencyPipe } from 'pipes/currency.pipe';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { AccountingService } from 'services/accounting.service';
import { ProductPlanService } from 'services/productplan.service';
import { SettlementProductPlansComponent } from './settlement-product-plans.component';
import { BrandService } from 'services/brand.service';
import { BrandModel } from 'models/generated/Entities.GormCrm.Brand';

@Component({
	selector: 'settlement',
	templateUrl: './settlement.component.html',
	imports: [Layout, SettlementProductPlansComponent, SummaryComponent, ListView, CurrencyPipe, TranslatePipe, CustomDatePipe]
})
export class SettlementComponent {

	public settlementStatus = SettlementStatus;
	private _settlement: SettlementModel = new SettlementModel();
	brand?: BrandModel;

	@Input()
	set settlement(settlement: SettlementModel) {
		this._settlement = settlement;
		this.brand = this.brandService.getBrand(settlement.settlementProductPlans[0]?.productPlan?.brandId) ?? undefined;
		this.settlementSum = (settlement.settlementProductPlans.map(spp => Math.ceil(100 * spp.amount)).reduce((partialSum, amount) => partialSum + amount, 0) ?? 0) / 100;
		this.load();
	}
	get settlement() { return this._settlement; }

	private _plansAmount: AccountingPlansLedgerPostsAmounts = new AccountingPlansLedgerPostsAmounts();
	@Input()
	set plansAmount(plansAmount: AccountingPlansLedgerPostsAmounts) {
		this._plansAmount = plansAmount;
		this.totalOpenAmount = plansAmount.totalOpenAmounts();
		this.totalClosedAmount = plansAmount.totalClosedAmounts();
	}
	get plansAmount() { return this._plansAmount; }	

	loading = true;
	totalOpenAmount:number = 0;
	totalClosedAmount:number = 0;
	totalPlansValue:number = 0;
	settlementSum:number = 0;

	constructor(private readonly productPlanService: ProductPlanService, private readonly brandService: BrandService) {}

	addVat(amount: number) {
		return AccountingService.addVat(amount);
	}

	load() {
		this.loading = true;	
		this.productPlanService.getAllProductPlansAndAccountingPlansForSettlement(this.settlement).then(settlement => {
			this.totalPlansValue = settlement.settlementProductPlans.map(spp => spp.productPlan!.accountingPlan.totalPlanValue).reduce((partialSum, amount) => partialSum + amount, 0) ?? 0;
			this.loading = false;
		});
	}
}
